import { Industry } from '__generated__/Industry';
import IndustryField from 'projects/components/BriefFields/IndustryField';
import OtherField from 'projects/components/BriefFields/OtherField';
import ProfileApprovalField from 'projects/components/BriefFields/ProfileApprovalField';
import UrlsField from 'projects/components/BriefFields/UrlsField';
import ContentSetting from 'projects/components/ContentSetting';
import { ObservableForm } from 'projects/components/ObservableForm';
import { trackViewedBriefEvent } from 'projects/events';
import React, { useEffect } from 'react';

interface Fields {
    industry: string;
    urls: string[];
    profileApproval: boolean;
    other: string;
}

interface Props<T> {
    form: ObservableForm<T>;
    industries: Industry[];
    brief: { id: string; designers: { displayName: string }[] };
}

const AboutYouPage: <T extends Fields>(props: Props<T>) => React.ReactElement<Props<T>> = ({
    form,
    industries,
    brief,
}) => {
    useEffect(() => {
        trackViewedBriefEvent({
            id: brief.id,
            page: 'AboutYou',
        });
    }, []);

    return (
        <ContentSetting>
            <IndustryField form={form} industries={industries} />
            <UrlsField form={form} title={__('Link to your existing website or store')} />
            <ProfileApprovalField form={form} />
            <OtherField form={form} />
        </ContentSetting>
    );
};

export default AboutYouPage;
